import { render, staticRenderFns } from "./ComboboxEncontroTipo.vue?vue&type=template&id=9b279334"
import script from "./ComboboxEncontroTipo.vue?vue&type=script&lang=js"
export * from "./ComboboxEncontroTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports